<section class="supporting-documents">
  <div class="supporting-documents-header">
    <h3>Documentos de apoyo</h3>
    @if (uploadsEnabled() && patientId()) {
      <input #fileInput type="file" multiple hidden (change)="onFilesSelected($event)" />
      <button mat-stroked-button type="button" (click)="fileInput.click()">Subir archivos</button>
    } @else {
      <button mat-stroked-button type="button" class="upload-slot-placeholder" tabindex="-1" disabled aria-hidden="true">
        Subir archivos
      </button>
    }
  </div>

  @if (!uploadsEnabled() || !patientId()) {
    <p class="supporting-documents-hint supporting-documents-status">
      Guarda el paciente para poder subir documentos de apoyo.
    </p>
  } @else if (loading()) {
    <div class="supporting-documents-loading supporting-documents-status">
      <mat-spinner diameter="28"></mat-spinner>
    </div>
  } @else if (items().length === 0 && pendingUploads().length === 0) {
    <p class="supporting-documents-hint supporting-documents-status">No hay documentos de apoyo todavía.</p>
  } @else {
    <table class="supporting-documents-table">
      <thead>
        <tr>
          <th>Archivo</th>
          <th>Fecha</th>
          <th>Subido por</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        @for (pending of pendingUploads(); track pending.key) {
          <tr class="pending-row">
            <td>{{ pending.fileName }}</td>
            <td colspan="2">Subiendo…</td>
            <td><mat-spinner diameter="20"></mat-spinner></td>
          </tr>
        }
        @for (document of items(); track document.id) {
          <tr>
            <td>{{ document.fileName }}</td>
            <td>{{ document.uploadedAt.toDate() | date: 'dd/MM/yyyy HH:mm' }}</td>
            <td>{{ document.uploadedByName || '—' }}</td>
            <td class="actions">
              <button mat-icon-button type="button" (click)="download(document)" aria-label="Descargar">
                <mat-icon>cloud_download</mat-icon>
              </button>
              <button mat-icon-button type="button" (click)="remove(document)" aria-label="Eliminar">
                <mat-icon>delete</mat-icon>
              </button>
            </td>
          </tr>
        }
      </tbody>
    </table>
  }
</section>
